<template>
    <div class="containerCD">
        <v-row>
            <v-col lg=12 cols=12 style="margin: 0 auto;">
                <v-card>
                    <v-card-title class="justify-center primary">
                        <v-icon class="pr-4" :color="'#FFFFFF'">mdi-file-pdf</v-icon>
                        <v-toolbar-title id="titulocard"> Dividir PDF</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <template v-if="!cargando">
                        <v-card-text class="pa-5 pt-4" v-if="numArchivos">
                            <v-row>
                                <v-col md="6" offset-md="2">
                                    <span style="text-align: center;font-size: medium;">Tipo de Documento:</span>
                                    <p style="font-weight: 600; font-size: x-large;">{{ this.tipoDocumento }}</p>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col md="9" offset-md="2">
                                    <span style="text-align: center;font-size: medium;">El archivo cuenta </span>
                                    <b style="font-size: large;"> {{ this.paginas }}</b>
                                    <span style="text-align: center;font-size: medium;"> PDF(s).
                                        La página mostrada actualmente será la que se procesará para dividir el
                                        archivo.
                                        Asegúrese de que es la correcta antes de continuar.</span>
                                    <v-progress-linear :active="loading" :indeterminate="loading" color="primary"
                                        class="mb-0"></v-progress-linear>
                                </v-col>
                            </v-row>
                            <v-row justify="center" style="margin-top: 2%;">
                                <div class="btnSI">
                                    <v-col class="justify-center align-center" cols="12" md="1" align="center" xs="4"
                                        justify="center">
                                        <v-container bg fill-height grid-list-md text-xs-center>
                                            <v-layout row wrap align-center>
                                                <v-flex>
                                                    <v-btn icon class="ma-2 align-center" @click="Anterior()"
                                                        :loading="loading2" :disabled="disableL">
                                                        <v-icon>
                                                            mdi-chevron-left
                                                        </v-icon>
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-col>
                                </div>
                                <div class="btnSI">
                                    <v-col cols="12" md="1">
                                        <v-container bg fill-height grid-list-md text-xs-center>
                                            <v-layout row wrap align-center>
                                                <v-flex>
                                                    <v-btn icon class="ma-2 align-center" @click="Siguiente()"
                                                        :loading="loading3" :disabled="disableR">
                                                        <v-icon>
                                                            mdi-chevron-right
                                                        </v-icon>
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-col>
                                </div>
                            </v-row>
                            <v-row justify="center" style="margin-top: 2%;">
                                <div class="btnNO">
                                    <v-col class="hidden-sm-and-down justify-center align-center" cols="12" md="1"
                                        align="center" xs="4" justify="center">
                                        <v-container bg fill-height grid-list-md text-xs-center>
                                            <v-layout row wrap align-center>
                                                <v-flex>
                                                    <v-btn icon class="ma-2 align-center" @click="Anterior()"
                                                        :loading="loading2" :disabled="disableL">
                                                        <v-icon>
                                                            mdi-chevron-left
                                                        </v-icon>
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-col>

                                </div>
                                <v-col cols="12" md="8">
                                    <div class="border pa-4" style="height: 70vh;" id="ver">
                                    </div>
                                    <div v-if="loading == false"
                                        style="display: grid; place-items: center; font-size: x-large;">
                                        {{ this.contador }}/{{ this.paginas }}
                                    </div>
                                </v-col>
                                <div class="btnNO">
                                    <v-col cols="12" md="1">
                                        <v-container bg fill-height grid-list-md text-xs-center>
                                            <v-layout row wrap align-center>
                                                <v-flex>
                                                    <v-btn icon class="hidden-sm-and-down ma-2 align-center"
                                                        @click="Siguiente()" :loading="loading3" :disabled="disableR">
                                                        <v-icon>
                                                            mdi-chevron-right
                                                        </v-icon>
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-col>
                                </div>
                            </v-row>
                            <v-row justify="center" class="mb-10">
                                <v-col v-if="showErrorPaginas">
                                    <span class="errorStyle">El documento seleccionado solo contiene una página, no
                                        es posible hacer la división.</span>
                                </v-col>
                            </v-row>
                            <template v-if="!showErrorPaginas">
                                <v-form ref="form" v-model="valid" lazy-validation>
                                    <v-row v-for="(pdf, index) in listDiv" :key="index" class="mx-6">
                                        <v-col cols="12" md="5">
                                            <span style="text-align: center">Escriba el rango o número de páginas que
                                                necesita
                                                dividir:</span>
                                            <v-text-field outlined dense required v-model="pdf.paginas"
                                                placeholder="Escriba Ejemplo: 1,3,5 o 1-4" :rules="[v => !!v || 'Campo requerido',
                                                v => /^(\d+(-\d+)?)(,\d+(-\d+)?)*$/.test(v) || 'Formato inválido. Ej: 1,3,5 o 1-4',
                                                v => !/(^|,|\s)0(-0)?(,|$)/.test(v) || 'No se permite la página 0',
                                                v => !tienePaginasRepetidas(v) || 'No se permiten páginas duplicadas',
                                                v => validarRango(v) || `El archivo solo cuenta con ${maxPaginas} páginas`
                                                ]" @keypress="onlyNumbersCommasDashes"
                                                @focusout="validarPaginasLibres(index)" :error-messages="mensajeError"
                                                ref="campoPaginas">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="5">
                                            <span style="text-align: center">Tipo Documento:</span>
                                            <multiselect style="display: block; margin-bottom: 10px"
                                                deselect-label="No se puede remover el valor seleccionado"
                                                selected-label="Seleccionado"
                                                select-label="Seleccione tipo de docuemento" track-by="doclave"
                                                label="dodescrip" placeholder="Seleccione una opción"
                                                v-model="pdf.doclave" :options="tipoDoc.opcionesDoc"
                                                :allow-empty="false" @select="removeMultiSelectError(index)">
                                            </multiselect>
                                            <span v-if="errorDoc[index]" style="color: red">
                                                Debe seleccionar una opción
                                            </span>
                                        </v-col>
                                        <v-col cols="12" md="1" style="display: grid; place-content: center;">
                                            <v-btn class="mx-2" fab small color="primary" v-if="pdf.add"
                                                @click="AgregarDivision(index)" :disabled="disabledAdd">
                                                <v-icon dark> mdi-plus </v-icon>
                                            </v-btn>
                                            <v-btn class="mx-2" fab dark small color="error" v-if="pdf.remove"
                                                @click="EliminarDivision(index)">
                                                <v-icon dark> mdi-close </v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>

                            </template>

                        </v-card-text>
                        <v-card-text class="pa-5 pt-4" v-else>
                            <v-row class="mt-2 py-5 align-center justify-center" offset-md="2">
                                <v-col cols="12" class="text-center">
                                    <span style="text-align: center;font-size: medium;">Tipo de Documento:</span>
                                    <p style="font-weight: 600; font-size: x-large;">{{ this.tipoDocumento }}</p>
                                </v-col>
                            </v-row>
                            <v-row class="mt-2 py-5 align-center justify-center" offset-md="2">
                                <v-col cols="12" class="text-center">
                                    <h5 style="text-align: center;">El archivo no cuenta con al menos un archivo
                                        PDF.</h5>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-row justify="center" class="mb-10">
                                <template v-if="showBotones">
                                    <v-btn class="ma-2" color="#536DFE" style="color:white" @click="Guardar()"
                                        :disabled="disabledSave">
                                        Guardar
                                    </v-btn>
                                    <v-btn class="ma-2" @click="Limpiar()" color="default">
                                        Limpiar
                                    </v-btn>
                                </template>

                                <v-btn class="ma-2" color="error" @click="Cancelar()">
                                    Cancelar
                                </v-btn>
                            </v-row>
                        </v-card-actions>
                    </template>
                    <template v-else>
                        <v-row justify="center">
                            <v-col cols="12" md="7">
                                <v-skeleton-loader
                                    type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                            </v-col>
                        </v-row>
                    </template>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import Archivos from "@/services/Archivos/Archivos.service.js";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import vue2Dropzone from "vue2-dropzone";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        vueDropzone: vue2Dropzone,
    },
    data: function () {
        return {
            tipoDocumento: '',
            valid: true,
            nrreporte: "",
            svindice: "",
            aiclave: "",
            tipo: null,
            docid: "",
            doclave: 0,
            paginas: 0,
            numArchivos: false,
            pdfs: null,
            loading: true,
            loading2: false,
            loading3: false,
            disableL: true,
            disableR: false,
            contador: 1,
            divisiones: null,
            showDivisiones: false,
            tipoDoc: {
                opcionesDoc: [],
                doclave: "",
                dodescrip: "",
            },
            showCatalogo: false,
            listDiv: null,
            disabledSave: true,
            showBotones: false,
            cargando: true,
            archivoElegido: null,
            showErrorPaginas: false,
            errorDoc: [],
            disabledAdd: false,
            maxPaginas: 0,
            mensajeError: "",
            paginasLibres: "",
        }
    },
    computed: {
        ...mapState([
            "domain",
            "informationPage",
            "paginacion",
            "permission",
            "user"
        ])
    },
    watch: {
        'listDiv': {
            deep: true, // Permite detectar cambios dentro de los objetos del array
            handler(nuevaLista) {
                if (nuevaLista != null) {
                    this.showBotones = nuevaLista.every(item =>
                        item.paginas !== null && item.paginas !== "" &&
                        item.doclave !== null && item.doclave !== "");
                    this.disabledSave = !nuevaLista.every(item =>
                        item.paginas !== null && item.paginas !== "" &&
                        item.doclave !== null && item.doclave !== "");

                    this.disabledSave = !this.$refs.form.validate()
                } else {
                    this.showBotones = false;
                    this.disabledSave = true;
                }
            }
        },
        showBotones(val) {
            if (val && this.mensajeError != "") {
                this.disabledSave = true;
            } else if (val && this.mensajeError == "") {
                this.disabledSave = false;
            }
            this.disabledSave = !this.$refs.form.validate()
        },

    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        tienePaginasRepetidas(valor) {
            if (valor != null && valor != "") {
                const paginas = [];

                valor.split(',').forEach(rango => {
                    if (rango.includes('-')) {
                        let [inicio, fin] = rango.split('-').map(Number);
                        for (let i = inicio; i <= fin; i++) {
                            paginas.push(i);
                        }
                    } else {
                        paginas.push(Number(rango));
                    }
                });

                // Verifica si hay ceros
                if (paginas.includes(0)) return true;

                // Verifica si hay duplicados
                const set = new Set(paginas);
                return set.size !== paginas.length;
            }

        },
        onlyNumbersCommasDashes(e) {
            const regex = /[0-9,-]/;
            if (!regex.test(e.key)) {
                e.preventDefault();
            }
        },
        validarRango(valor) {
            if (!valor) return true; // Si está vacío, no validar
            const max = this.maxPaginas; // Variable que define el máximo permitido

            return valor.split(',').every(rango => {
                if (rango.includes('-')) {
                    const [inicio, fin] = rango.split('-').map(Number);
                    return inicio <= fin && fin <= max;
                } else {
                    return Number(rango) <= max;
                }
            });
        },
        async ValidarPDF() {
            //Validamos que el archivo contenga almenos un pdf
            let response = await Archivos.ExistePDF(this.datos, this.docid)

            if (response.msg != "") {
                this.numArchivos = true;
                // Transformar el string en un formato JSON válido
                const formattedString = `[${response.msg
                    .replace(/(\w+):/g, '"$1":') // Agregar comillas a las claves
                    .replace(/([^{}\s:,]+\/[^{}\s:,]+)/g, '"$1"') // Agregar comillas a los valores tipo string
                    }]`;
                // Convertir a array de objetos
                this.pdfs = JSON.parse(formattedString);
                this.paginas = this.pdfs.length;
                this.maxPaginas = this.pdfs[0]["totalPaginas"]
                //this.loading = false
            }
            this.cargando = false;
            if (this.numArchivos) {
                this.VerArchivo();
            }
        },
        async VerArchivo() {
            let dir = await Archivos.ObtenerDireccion(this.datos, this.docid, this.pdfs[0]["pagina"]);
            if (dir.archivo !== null) {
                this.disableR = this.paginas == 1 ? true : false;
                var iframe = document.createElement("iframe");
                iframe.setAttribute("src", dir.watch);
                iframe.style.width = "100%";
                iframe.style.height = "65vh";
                iframe.style.borderRadius = "1%";
                document.getElementById('ver').appendChild(iframe);
                this.archivoElegido = this.pdfs[0]
                if (this.archivoElegido.totalPaginas <= 1) {
                    this.showErrorPaginas = true;
                } else {
                    this.listDiv =
                        Array.from({ length: 1 }, () => ({
                            tipoDiv: null,
                            paginas: null,
                            doclave: null,
                            validacion: null,
                            placeholder: '',
                            add: true,
                            remove: false,
                            error: '',
                            nuevo: "N"
                        }));

                    this.disabledAdd = this.pdfs[0]["totalPaginas"] == 2 ? true : false;
                }

            } else {
                this.$swal({
                    position: 'center',
                    icon: 'warning',
                    title: 'Error',
                    text: dir.msg,
                    showConfirmButton: false,
                    timer: 2500
                });
            }
            this.loading = false;
        },
        Siguiente() {
            this.disableR = true;
            this.loading = true;
            this.loading3 = true;
            this.loading2 = true;
            this.disableR = false;
            this.disableL = false;
            this.showErrorPaginas = false;
            this.contador++;
            if (document.querySelector("iframe") != null) {
                document.querySelector("iframe").remove();
            }
            this.BurcarArchivo();
            if (this.contador == this.paginas) {
                this.contador = this.paginas;
                this.disableR = true;
            }

        },
        async BurcarArchivo() {
            let aux = this.contador - 1;
            let data = await Archivos.ObtenerDireccion(this.datos, this.docid, this.pdfs[aux]["pagina"]);

            if (data.archivo !== null) {
                var iframe = document.createElement("iframe");
                iframe.setAttribute("src", data.watch);
                iframe.style.width = "100%";
                iframe.style.height = "65vh";
                iframe.style.borderRadius = "1%";
                document.getElementById('ver').appendChild(iframe);
                this.archivoElegido = this.pdfs[aux]
                this.maxPaginas = this.pdfs[aux]["totalPaginas"]

                if (this.archivoElegido.totalPaginas <= 1) {
                    this.showErrorPaginas = true;
                } else {
                    this.listDiv =
                        Array.from({ length: 1 }, () => ({
                            tipoDiv: null,
                            paginas: null,
                            doclave: null,
                            validacion: null,
                            placeholder: '',
                            add: true,
                            remove: false,
                            error: '',
                            nuevo: "N"
                        }));
                    this.disabledAdd = this.pdfs[aux]["totalPaginas"] == 2 ? true : false;

                }
            }
            else {
                this.$swal({
                    position: 'center',
                    icon: 'warning',
                    title: 'Error',
                    text: data.msg,
                    showConfirmButton: false,
                    timer: 2500
                });

            }
            this.loading2 = false;
            this.loading3 = false;
            this.loading = false;

        },
        Anterior() {
            this.disableL = true;
            this.loading = true;
            this.loading3 = true;
            this.loading2 = true;
            this.disableL = false;
            this.disableR = false;
            this.showErrorPaginas = false;
            this.contador = this.contador - 1
            if (document.querySelector("iframe") != null) {
                document.querySelector("iframe").remove();
            }
            this.BurcarArchivo();

            if (this.contador == 1) {
                this.contador == 1;
                this.disableL = true;
            }
        },
        async obtenerEstadoReporte() {
            this.tipo = await MetodosGenerales.getReporteEstatus(this);
        },
        async Guardar() {
            if (this.$refs.form.validate()) {
                this.$swal({
                    title: 'Dividiendo PDF... ',
                    html: `Espere un momento, por favor`,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        this.listDiv.forEach((pdf, i) => {
                            const paginas = pdf.paginas.replace(/\s/g, ''); // limpiar espacios

                            let tienePaginas = false;
                            let tieneRangos = false;

                            if (paginas.includes('-')) {
                                tieneRangos = true;
                            }
                            if (paginas.includes(',')) {
                                tienePaginas = true;
                            }

                            if (tienePaginas && tieneRangos) {
                                pdf.tipoDiv = 'M'; // Mixto
                            } else if (tieneRangos) {
                                pdf.tipoDiv = 'R'; // Rango
                            } else {
                                pdf.tipoDiv = 'P'; // Páginas
                            }
                            pdf.paginas.split(',').forEach(rango => {

                                if (rango.includes('-')) {
                                    let [inicio, fin] = rango.split('-').map(Number);
                                    pdf.inicio = inicio;
                                    pdf.fin = fin;
                                } else {
                                    pdf.inicio = 0;
                                    pdf.fin = 0;
                                }
                            });

                        });

                        let response = await Archivos.DividirArchivo(this.datos, this.docid, this.archivoElegido.pagina, this.listDiv, this.doclave, this.paginasLibres.join(','))
                        if (!response.error) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se dividio el archivo exitosamente.',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                await this.Cancelar();
                            })

                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Error',
                                text: 'Ocurrio un error, al dividir el archivo. Intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: false,
                                timer: 2500
                            });
                        }
                    }
                })
            }
        },
        removeMultiSelectError(index) {
            this.$set(this.errorDoc, index, false);
        },
        Limpiar() {
            //this.showDivisiones = false;
            this.listDiv =
                Array.from({ length: 1 }, () => ({
                    tipoDiv: null,
                    paginas: null,
                    doclave: null,
                    validacion: null,
                    placeholder: '',
                    add: true,
                    remove: false,
                    error: '',
                    nuevo: "N"
                }));
            this.disabledAdd = this.pdfs[0]["totalPaginas"] == 2 ? true : false;
            this.$refs.form.reset();
        },
        async Cancelar() {
            this.disabled = true;
            let asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
            this.$router.push({ path: asistenciaurl + '/Archivos' });
            if (this.numArchivos) {
                document.querySelector("iframe").remove();
            }
        },
        async AgregarDivision(index) {
            let valid = await this.ValidacionFormulario(index)
            if (valid == 0) {
                this.listDiv[index]['add'] = false;
                this.listDiv[index]['remove'] = true;
                this.listDiv.push({
                    tipoDiv: null,
                    paginas: null,
                    doclave: null,
                    validacion: null,
                    placeholder: '',
                    add: true,
                    remove: false,
                    error: '',
                    nuevo: "N"
                });
            }
        },
        async ValidacionFormulario(index) {
            let val = 0;
            const valid = await this.$refs.form.validate();
            if (!valid) {
                val++;
            }
            if (!this.listDiv[index].doclave) {
                this.$set(this.errorDoc, index, true);
                val++
            } else {
                this.$set(this.errorDoc, index, false);
            }
            return val;
        },
        async EliminarDivision(index) {
            this.listDiv.splice(index, 1);
        },
        async validarPaginasLibres(index) {
            const valor = this.listDiv[index]["paginas"];
            if (valor !== "" && valor !== null) {
                let seleccionadas = new Set();
                let todasOcupadas = new Set(); // Para verificar si todas están en uso
                this.listDiv.forEach((pdf, i) => {
                    if (i !== index) {
                        pdf.paginas.split(',').forEach(rango => {
                            if (rango.includes('-')) {
                                let [inicio, fin] = rango.split('-').map(Number);
                                for (let i = inicio; i <= fin; i++) {
                                    todasOcupadas.add(i);
                                }
                            } else {
                                todasOcupadas.add(Number(rango));
                            }
                        });
                    }
                });


                // Convertir el valor actual en un conjunto de páginas seleccionadas
                valor.split(',').forEach(rango => {
                    if (rango.includes('-')) {
                        let [inicio, fin] = rango.split('-').map(Number);
                        for (let i = inicio; i <= fin; i++) {
                            seleccionadas.add(i);
                        }
                    } else {
                        seleccionadas.add(Number(rango));
                    }
                });

                let paginasUsadas = new Set([...seleccionadas, ...todasOcupadas]);


                // 1- Verificar que no se repitan páginas con otras divisiones
                for (let pagina of seleccionadas) {
                    if (todasOcupadas.has(pagina)) {
                        this.mensajeError = `La página ${pagina} ya está seleccionada en otra división.`;
                        this.disabledSave = true;
                        return;
                    }
                }

                // 2- Verificar que al menos una página quede libre
                if (paginasUsadas.size >= this.maxPaginas) {
                    this.mensajeError = "Debe dejar al menos una página sin seleccionar";
                    this.disabledAdd = true;
                    this.disabledSave = true;
                } else {
                    this.mensajeError = ""; // No hay error
                }

                let countPagUsadas = paginasUsadas.size

                if ((countPagUsadas + 1) >= this.maxPaginas) {
                    this.disabledAdd = true;
                } else {
                    this.disabledAdd = false;
                }

                // Generar el string de páginas libres
                this.paginasLibres = [];
                for (let i = 1; i <= this.maxPaginas; i++) {
                    if (!paginasUsadas.has(i)) {
                        this.paginasLibres.push(i);
                    }
                }
            }


        }
    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "397").then((response) => {
            if (response.data.length == 0) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                return
            }
        });
    },
    async mounted() {
        this.changeReporteMenuOption('NoView');
        this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        let doc = await MetodosGenerales.obtenerSessionReporte('documento');
        this.nrreporte = this.datos.nrreporte;
        this.svindice = this.datos.svindice;
        this.aiclave = this.datos.aiclave;
        this.docid = doc.docid
        this.tipoDocumento = doc.dodescrip
        this.doclave = doc.doclave
        await this.obtenerEstadoReporte();
        Archivos.ObtenerCatalogoDocs(this, this.datos);
        await this.ValidarPDF();
    }

}
</script>
<style scoped>
.containerCD .theme--light.v-card>.v-card__text,
.containerCD .theme--light.v-card>.v-card__subtitle {
    color: rgb(0, 0, 0);
}

.theme--dark.v-card>.v-card__text,
.theme--dark.v-card>.v-card__subtitle {
    color: rgb(255, 255, 255);
}

.vue-dropzone {
    border: 2px solid #e5e5e5;
    font-family: Arial, sans-serif;
    letter-spacing: .2px;
    color: #777;
    transition: .2s linear;
    z-index: 3;
    position: relative;
}

.errorStyle {
    color: #FF5C93;
    font-size: small;
    display: grid;
    place-items: center;
}
</style>